var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.354 4.354a.5.5 0 000-.708L16.172.464a.5.5 0 10-.708.708L18.293 4l-2.829 2.828a.5.5 0 10.708.708l3.182-3.182zM0 4.5h19v-1H0v1z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMjAgOCIgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBkPSJNMTkuMzUzNiA0LjM1MzU1QzE5LjU0ODggNC4xNTgyOSAxOS41NDg4IDMuODQxNzEgMTkuMzUzNiAzLjY0NjQ1TDE2LjE3MTYgMC40NjQ0NjZDMTUuOTc2MyAwLjI2OTIwNCAxNS42NTk3IDAuMjY5MjA0IDE1LjQ2NDUgMC40NjQ0NjZDMTUuMjY5MiAwLjY1OTcyOCAxNS4yNjkyIDAuOTc2MzExIDE1LjQ2NDUgMS4xNzE1N0wxOC4yOTI5IDRMMTUuNDY0NSA2LjgyODQzQzE1LjI2OTIgNy4wMjM2OSAxNS4yNjkyIDcuMzQwMjcgMTUuNDY0NSA3LjUzNTUzQzE1LjY1OTcgNy43MzA4IDE1Ljk3NjMgNy43MzA4IDE2LjE3MTYgNy41MzU1M0wxOS4zNTM2IDQuMzUzNTVaTTAgNC41SDE5VjMuNUgwVjQuNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==";
export { SvgArrowRight as ReactComponent };